var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"dropdown",class:[ ("dropdown--anchor-" + _vm.anchor), { 'dropdown--minwidth': _vm.minWidth } ]},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }